import type { FabricEditor } from 'modules/fabric-editor';
import { useEffect, useState } from 'react';

export function useEditorDirty(editor: FabricEditor | null): boolean {
  const [isDirty, setIsDirty] = useState<boolean>(() => editor?.dirty?.isDirty() ?? false);

  useEffect(() => {
    if (!editor) {
      setIsDirty(false);
      return;
    }
    setIsDirty(editor.dirty?.isDirty() ?? false);
    const off = editor.on('dirty:changed', ({ isDirty: next }) => setIsDirty(next));
    return off;
  }, [editor]);

  return isDirty;
}
